import { Media } from '@kiwicom/account-global-contexts';
import { Layout, Skeleton } from '@kiwicom/orbit-components';
import { useIntl } from 'react-intl';

const WalletPlaceholder = (): JSX.Element => {
  const intl = useIntl();

  return (
    <Layout type="MMB">
      <Media greaterThanOrEqual="tablet">
        <Skeleton
          width="100%"
          height={600}
          dataTest="WalletPlaceholder-Desktop"
          title={intl.formatMessage({
            id: 'common.loading',
            defaultMessage: 'Loading',
          })}
        >
          <rect x="0%" rx="4" ry="3" y="7" height="32" width="285px" />
          <rect x="0%" rx="4" ry="3" y="65" height="114" width="100%" />
          <rect x="0%" rx="4" ry="3" y="200" height="300" width="100%" />
        </Skeleton>
      </Media>
      <Media between={['mediumMobile', 'largeMobile']}>
        <Skeleton
          width="100%"
          height={600}
          dataTest="WalletPlaceholder-Mobile"
          title={intl.formatMessage({
            id: 'common.loading',
            defaultMessage: 'Loading',
          })}
        >
          <rect x="0%" rx="4" ry="3" y="5" height="20" width="200" />
          <rect x="0%" rx="4" ry="3" y="40" height="16" width="400" />
          <rect x="0%" rx="4" ry="3" y="63" height="16" width="200" />
          <rect x="0%" rx="4" ry="3" y="112" height="88" width="100%" />
          <rect x="0%" rx="4" ry="3" y="218" height="300" width="100%" />
        </Skeleton>
      </Media>
      <Media lessThan="mediumMobile">
        <Skeleton
          width="100%"
          height={600}
          dataTest="WalletPlaceholder-SmallMobile"
          title={intl.formatMessage({
            id: 'common.loading',
            defaultMessage: 'Loading',
          })}
        >
          <rect x="0%" rx="4" ry="3" y="5" height="56" width="100%" />
          <rect x="0%" rx="4" ry="3" y="85" height="213" width="100%" />
          <rect x="0%" rx="4" ry="3" y="320" height="300" width="100%" />
        </Skeleton>
      </Media>
    </Layout>
  );
};

export default WalletPlaceholder;
